<script setup lang="ts">
import Error from '@/components/Error.vue';
</script>

<template>
  <error
    :icon="'mdi-alert-circle'"
    :title="'Unable to check in'"
    :message="'Please confirm the information with your dispatcher or reach out to the warehouse'" />
</template>
